/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import { updateLabelRequestSchema } from '../campaign-schema';

export const updateCampaignCreatorLabelPathSchema = z.object({
  campaignId: z.string(),
  campaignCreatorId: z.string(),
});

export const updateCampaignCreatorLabelRequestBodySchema =
  updateLabelRequestSchema;

export type UpdateCampaignCreatorLabelInput = {
  path: z.input<typeof updateCampaignCreatorLabelPathSchema>;
  body?: z.input<typeof updateCampaignCreatorLabelRequestBodySchema>;
  signal?: AbortSignal;
};

export async function updateCampaignCreatorLabel({
  path,
  body,
  signal,
}: UpdateCampaignCreatorLabelInput): Promise<void> {
  const parsedPath = updateCampaignCreatorLabelPathSchema.parse(path);
  const parsedBody =
    body === undefined
      ? undefined
      : updateCampaignCreatorLabelRequestBodySchema.parse(body);

  await socialApiClient.patch(
    `campaigns/${parsedPath.campaignId}/creators/${parsedPath.campaignCreatorId}/label`,
    {
      signal,
      ...(parsedBody === undefined ? {} : { json: parsedBody }),
    },
  );
}
